import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteWorkOrderActions'
import { getAllTasks } from '../tasksSaga'
import * as api from '../../api/job/jobSiteWorkOrders'

function* jobSiteWorkOrdersRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteWorkOrders, action.jobId)
    yield put({ type: constants.JOB_SITE_WORK_ORDERS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_WORK_ORDERS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteWorkOrders() {
  yield takeLatest(constants.JOB_SITE_WORK_ORDERS_REFRESH.ACTION, jobSiteWorkOrdersRefresh)
}

function* sagaCreateJobSiteWorkOrder(action) {
  try {
    if (action.content.work_order_template_id.toString() === '')
      action.content.work_order_template_id = null
    const payload = {
      job_id: action.jobId,
      work_order_data: action.content,
      work_order_tasks: action.workOrderItems,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createWorkOrder, payload)
    yield put({ type: constants.JOB_SITE_WORK_ORDER_CREATE.SUCCESS, payload })
    yield call(jobSiteWorkOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_WORK_ORDER_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteWorkOrder() {
  yield takeLatest(constants.JOB_SITE_WORK_ORDER_CREATE.ACTION, sagaCreateJobSiteWorkOrder)
}

function* sagaUpdateJobSiteWorkOrder(action) {
  try {
    const payload = {
      work_order_id: action.workOrderId,
      job_id: action.jobId,
      work_order_data: action.content,
      updated_by_id: action.userId,
      work_order_tasks: action.workOrderItems
    }
    yield call(api.updateWorkOrder, payload)
    yield put({ type: constants.JOB_SITE_WORK_ORDER_UPDATE.SUCCESS, payload })
    yield call(jobSiteWorkOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_WORK_ORDER_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteWorkOrder() {
  yield takeLatest(constants.JOB_SITE_WORK_ORDER_UPDATE.ACTION, sagaUpdateJobSiteWorkOrder)
}

function* sagaDeleteJobSiteWorkOrder(action) {
  try {
    const payload = {
      work_order_id: action.workOrderId
    }
    yield call(api.deleteWorkOrder, payload)
    yield put({ type: constants.JOB_SITE_WORK_ORDER_DELETE.SUCCESS, payload })
    yield call(jobSiteWorkOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_WORK_ORDER_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteWorkOrder() {
  yield takeLatest(constants.JOB_SITE_WORK_ORDER_DELETE.ACTION, sagaDeleteJobSiteWorkOrder)
}

function* getWorkOrderItems(action) {
  try {
    const payload = yield call(api.getJobSiteWorkOrderItems, action.workOrderId)
    yield put({ type: constants.GET_WORK_ORDER_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_WORK_ORDER_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetWorkOrderItems() {
  yield takeLatest(constants.GET_WORK_ORDER_ITEMS.ACTION, getWorkOrderItems)
}

function* markTaskComplete(action) {
  try {
    yield call(api.markTaskComplete, action.taskId)
    yield put({ type: constants.MARK_TASK_COMPLETE.SUCCESS, data: 'OK' })
    yield call(getWorkOrderItems, { workOrderId: action.workOrderId })
    yield call(jobSiteWorkOrdersRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MARK_TASK_COMPLETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchMarkTaskCompletes() {
  yield takeLatest(constants.MARK_TASK_COMPLETE.ACTION, markTaskComplete)
}

function* sagaQuickAddTask(action) {
  try {
    const payload = {
      name: action.task.name,
      type: action.task.type,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.quickAddTask, payload)
    yield put({ type: constants.QUICK_ADD_TASK.SUCCESS, payload })
    yield call(getAllTasks)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.QUICK_ADD_TASK.FAILED,
      message: e.message || e
    })
  }
}

function* watchQuickAddTask() {
  yield takeLatest(constants.QUICK_ADD_TASK.ACTION, sagaQuickAddTask)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteWorkOrders),

    fork(watchCreateJobSiteWorkOrder),
    fork(watchUpdateJobSiteWorkOrder),
    fork(watchDeleteJobSiteWorkOrder),

    fork(watchGetWorkOrderItems),
    fork(watchMarkTaskCompletes),

    fork(watchQuickAddTask)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteWorkOrderSaga.js